export default __webpack_public_path__ + "static/media/fontMulish400_vietnamese.13b8f8d3.woff2";